import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import MuiLayersOutlined from '@mui/icons-material/LayersOutlined';

export const ContentTitle = styled.p`
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  font-weight: 700;
  margin: 6px 0 0 0;
  text-transform: uppercase;
  letter-spacing: 2px;
`;

export const LayersOutlined = styled(MuiLayersOutlined)`
  color: #fff;
  font-size: 16px;
  margin-right: 6px;
` as React.FC<PropsWithChildren<React.ComponentProps<typeof MuiLayersOutlined>>>;
